import React, { useState, useEffect } from 'react';

import { toast } from 'react-toastify';
import firebase from './../../../../firebase';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';

const ProfileSettings = () => {
   
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    firstName: null,
    lastName: null,
    email: null,
    phone: null
   });

  useEffect(()=> {
    firebase.auth().onAuthStateChanged((user) => {
      if (user)  {
        firebase.firestore().collection('users').doc(user.uid).get().then(doc => {
          if (doc){ 
            let d = doc.data()
            d.id = doc.id;
            setFormData(d) 
          }
        })
      }else{
        toast.error('Une erreur s\'est produite.');
      }
    })
  }, [])

  const handleChange = e => { 
    let d = {id: formData.id};
    d.firstName = formData.firstName;
    d.lastName = formData.lastName;
    d.email = formData.email;
    d.phone = formData.phone;
    d[e.target.name] = e.target.value;
    setFormData(d); 
  };

  const handleSubmit = e => {
    e.preventDefault(); 
    console.log(formData);
    if (formData && formData.firstName && formData.lastName && formData.phone && formData.id){
      const da = {
        firstName : formData.firstName, 
        lastName:formData.lastName , 
        phone : formData.phone, 
        update_At: new Date()
      }
      setLoading(true);
      firebase.firestore().collection('users').doc(formData.id).update(da).then((res) => {
        setLoading(false);
        toast.success('Mise à jour terminé');
      }).catch(err => {
        setLoading(false);
        toast.error('Une erreur s\'est produite.');
      })
    }else{
      toast.error('Veuillez remplir tout les champs.');
    }
  };

  return (
    <Card>
      <FalconCardHeader title="Information de profile" />
      <Card.Body className="bg-body-tertiary">
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3 g-3">
            <Form.Group as={Col} lg={6} controlId="firstName">
              <Form.Label>Prénom</Form.Label>
              <Form.Control
                type="text"
                placeholder="Prénom"
                value={formData.firstName}
                name="firstName"
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group as={Col} lg={6} controlId="lastName">
              <Form.Label>Nom de famille</Form.Label>
              <Form.Control
                type="text"
                placeholder="Last Name"
                value={formData.lastName}
                name="lastName"
                onChange={handleChange}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3 g-3">
            <Form.Group as={Col} lg={6} controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email"
                value={formData.email}
                name="email"
                disabled
                // onChange={handleChange}
              />
            </Form.Group>

            <Form.Group as={Col} lg={6} controlId="phone">
              <Form.Label>Téléphone</Form.Label>
              <Form.Control
                type="text"
                placeholder="Phone"
                value={formData.phone}
                name="phone"
                onChange={handleChange}
              />
            </Form.Group>
          </Row> 

          <div className="text-end">
            <Button variant="primary" type="submit" disabled={loading}>
              {!loading ? 'Mise à jour': 'Chargement'}
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default ProfileSettings;
